__turbopack_context__.v({
  "large": "Skeleton-module-scss-module__Bh7Oma__large",
  "skeleton": "Skeleton-module-scss-module__Bh7Oma__skeleton",
  "skeleton-loading": "Skeleton-module-scss-module__Bh7Oma__skeleton-loading",
  "skeletonList": "Skeleton-module-scss-module__Bh7Oma__skeletonList",
  "skeletonSquare": "Skeleton-module-scss-module__Bh7Oma__skeletonSquare",
  "skeletonText": "Skeleton-module-scss-module__Bh7Oma__skeletonText",
});
